import PlatformEvent from "../PlatformEvent"

export default new PlatformEvent("INFO", "PreviousFail", "PreviousFail", false)